var pad = require("./pad");
module.exports = function rpad(str, length, padStr) {
  return pad(str, length, padStr, "right");
};
